// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-select .v-field .v-text-field__prefix,
.v-select .v-field .v-text-field__suffix,
.v-select .v-field .v-field__input, .v-select .v-field.v-field {
  cursor: pointer;
}
.v-select .v-field .v-field__input > input {
  align-self: flex-start;
  opacity: 1;
  flex: 0 0;
  position: absolute;
  width: 100%;
  transition: none;
  pointer-events: none;
  caret-color: transparent;
}
.v-select .v-field--dirty .v-select__selection {
  margin-inline-end: 2px;
}
.v-select .v-select__selection-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.v-select__content {
  overflow: hidden;
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
  border-radius: 4px;
}
.v-select__selection {
  display: inline-flex;
  align-items: center;
  letter-spacing: inherit;
  line-height: inherit;
  max-width: 100%;
}
.v-select .v-select__selection:first-child {
  margin-inline-start: 0;
}
.v-select--selected .v-field .v-field__input > input {
  opacity: 0;
}
.v-select__menu-icon {
  margin-inline-start: 4px;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.v-select--active-menu .v-select__menu-icon {
  opacity: var(--v-high-emphasis-opacity);
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSelect/VSelect.css"],"names":[],"mappings":"AAAA;;;EAGE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wOAAwO;EACxO,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;AACA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B","sourcesContent":[".v-select .v-field .v-text-field__prefix,\n.v-select .v-field .v-text-field__suffix,\n.v-select .v-field .v-field__input, .v-select .v-field.v-field {\n  cursor: pointer;\n}\n.v-select .v-field .v-field__input > input {\n  align-self: flex-start;\n  opacity: 1;\n  flex: 0 0;\n  position: absolute;\n  width: 100%;\n  transition: none;\n  pointer-events: none;\n  caret-color: transparent;\n}\n.v-select .v-field--dirty .v-select__selection {\n  margin-inline-end: 2px;\n}\n.v-select .v-select__selection-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.v-select__content {\n  overflow: hidden;\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n  border-radius: 4px;\n}\n.v-select__selection {\n  display: inline-flex;\n  align-items: center;\n  letter-spacing: inherit;\n  line-height: inherit;\n  max-width: 100%;\n}\n.v-select .v-select__selection:first-child {\n  margin-inline-start: 0;\n}\n.v-select--selected .v-field .v-field__input > input {\n  opacity: 0;\n}\n.v-select__menu-icon {\n  margin-inline-start: 4px;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-select--active-menu .v-select__menu-icon {\n  opacity: var(--v-high-emphasis-opacity);\n  transform: rotate(180deg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
